<template>
  <v-tabs color="primary">
    <v-tab v-for="(categoria, index) in perguntas" :key="index">{{
      categoria.grupo
    }}</v-tab>
    <v-tab-item v-for="(categoria, index) in perguntas" :key="index">
      <v-card flat>
        <v-card-text class="pa-0">
          <v-expansion-panels class="pt-1" accordion>
            <v-expansion-panel
              v-for="(item, index) in categoria.listaPergunta"
              :key="index"
            >
              <v-expansion-panel-header>{{
                item.pergunta
              }}</v-expansion-panel-header>
              <v-expansion-panel-content class="grey--text">{{
                item.resposta
              }}</v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  props: {
    perguntas: {
      type: Array,
    },
  },
};
</script>
